// extracted by mini-css-extract-plugin
export default {"productPageContentCard":"product-page-content_productPageContentCard__y2cP6"};